var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSeoSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7002 35.4L11.2849 30.8153M11.2849 30.8153C12.069 31.5994 12.9998 32.2214 14.0243 32.6457C15.0488 33.0701 16.1468 33.2885 17.2556 33.2885C18.3645 33.2885 19.4625 33.0701 20.487 32.6457C21.5114 32.2214 22.4423 31.5994 23.2264 30.8153C24.0105 30.0312 24.6325 29.1004 25.0568 28.0759C25.4811 27.0514 25.6996 25.9534 25.6996 24.8445C25.6996 23.7357 25.4811 22.6377 25.0568 21.6132C24.6325 20.5887 24.0105 19.6579 23.2264 18.8738C21.6428 17.2903 19.4951 16.4006 17.2556 16.4006C15.0162 16.4006 12.8684 17.2903 11.2849 18.8738C9.70135 20.4573 8.81173 22.6051 8.81173 24.8445C8.81173 27.084 9.70135 29.2318 11.2849 30.8153Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90002 26.2572C1.65188 24.1069 0.99627 21.6641 1.00002 19.1778C1.00002 11.3479 7.38021 5 15.25 5H24.75C32.6198 5 39 11.3479 39 19.1778C39 25.3528 35.0347 30.6044 29.5 32.55",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeoSearch);
export default __webpack_public_path__ + "static/media/icon-seo-search.492eeb64eb62bd30389898a700da9679.svg";
export { ForwardRef as ReactComponent };